<template>
  <div class="k-sidebar" :data-color="activeColor"
       :data-background-color="backgroundColor">
    <div class="header">
      <a href="javascript:void(0)" class="logo-img">
        <div class="logo-img">
          <img src="/static/images/kayakwise.png" alt=""/>
        </div>
      </a>
      <!--      <a href="javascript:void(0)" class="logo-img">-->
      <!--        <div class="logo-img">-->
      <!--          <img src="../../assets/img/kayakwise.png" alt=""></img>-->
      <!--        </div>-->
      <!--      </a>-->
      <!--      <a href="javascript:void(0)" class="simple-text logo-normal">-->
      <!--        <template>{{ title }}</template>-->
      <!--      </a>-->
      <!-- <div class="navbar-minimize">
        <md-button id="minimizeSidebar" class="md-round md-just-icon md-transparent" @click="minimizeSidebar">
          <svg-icon v-if="showIcon" icon-class="unfold" width="14px" height="14px"></svg-icon>
          <svg-icon v-else icon-class="closure" width="14px" height="14px"></svg-icon>
        </md-button>
      </div> -->
    </div>

    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <div class="left-menu">
        <div style="height: 10px;border-bottom-right-radius: 3px;">

        </div>
        <div v-for="(m1,index) in menus" :key="m1.menuid" class="item" :class="{'item-selected':currentMenu1Index===index}"
             @click="clickMenuItem(m1,index)">
          <div class="item-content">
            <svg-icon icon-class="first-menu" width="16px" height="16px"></svg-icon>
            <span>{{ m1.shortname }}</span>
          </div>
          <div class="fg"></div>
        </div>
      </div>

      <div class="split-vertical"></div>

      <div class="right-menu">
        <div class="m1-menuname">
          {{ m1.menuname }}
        </div>
        <div class="split-horizon"></div>
        <ul class="nav">
          <li class="nav-li" v-for="(m2,index) in menus2" :key="m2.menuid" v-show="m2.upperid===m1.menuid"
              :class="{'nav-li-active':m2.active,'nav-li-unactive':!m2.active}">
            <component class="nav-link" :is="elementType(m2)"
                       :class="{'nav-link-active':m2.active,
                       'nav-li-unactive':!m2.active,
                       'route-active':m2.active,
                       'route-mutex': m2.m3Active,
                       'children-route-active':isChildrenActive(m2)}"
                       @click="clickMenu2Item(m2,index)">
            <!-- <component class="nav-link" :is="elementType(m2)"
                       :class="{'nav-link-active':m2.active,'nav-li-unactive':!m2.active,'route-active':isActive(m2),'children-route-active':isChildrenActive(m2)}"
                       :to="'/main/'+m2.url" :href="m2.url?'#/main/'+m2.url:'javascript:void(0);'"
                       @click="clickMenu2Item(m2,index)"> -->
              <template>
                <svg-icon icon-class="second-menu" width="12px" height="12px"></svg-icon>
                <span class="menuname">{{ m2.menuname }}</span>
                <img v-show="m2.children&&!m2.url&&backgroundColor==='black'" class="cert"
                     src="../../assets/svg/k-menu/down.svg" alt=""/>
                <img v-show="m2.children&&!m2.url&&backgroundColor==='red'" class="cert"
                     src="../../assets/svg/k-menu/down.svg" alt=""/>
                <img v-show="m2.children&&!m2.url&&backgroundColor==='white'" class="cert"
                     src="../../assets/svg/k-menu/down-black.svg" alt=""/>
              </template>
            </component>

            <div class="nav-li-menu">
              <ul class="nav-li-menu-nav" :style="setStyle(index,m2)">
                <li v-for="(m3, m3Index) in m2.children" :key="m3.menuid" class="nav-li-menu-nav-li">
                  <component class="nav-li-menu-nav-link" :class="{'route-active':m3.active}" :is="elementType(m3)"
                             @click="clickMenu3Item(m2, m3, index, m3Index)">
                    <template>
                      <span class="menuname">-&nbsp;&nbsp;&nbsp;{{ m3.menuname }}</span>
                      <img v-if="m3.children&&!m3.url" class="cert" src="../../assets/svg/k-menu/down.svg" alt=""/>
                    </template>
                  </component>
                </li>
              </ul>
            </div>
          </li>

        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
export default {
  name: "k-sider",
  props: {
    title: {
      type: String
    },
    activeColor: {
      type: String,
      default: "blue",
      validator: value => {
        let acceptedValues = [
          "",
          "purple",
          "azure",
          "green",
          "orange",
          "blue",
          "danger",
          "rose"
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    // backgroundImage: {
    //   type: String,
    //   default: "./img/sidebar-2.jpg"
    // },
    backgroundColor: {
      type: String,
      default: "blue",
      validator: value => {
        let acceptedValues = ["", "black", "white", "red", "blue"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    // logo: {
    //   type: String,
    //   default: "./../assets/img/menuLogo.png"
    // },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    },
    menus: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    // sidebarStyle() {
    //   return {
    //     backgroundImage: `url(${this.backgroundImage})`,
    //   };
    // },
    setStyle() {
      return function (index, m2) {
        if (m2.active) {
          return {
            maxHeight: m2.children ? m2.children.length * 46 + 80 + "px" : 0
          }
        } else {
          return {
            maxHeight: 0
          }
        }

      }
    },
    menus2() {
      let temp = []
      this.menus.forEach((item, index) => {
        if (item.children) {
          temp = temp.concat(item.children)
        }
      })
      return temp
    },
    microRouter() {
			return this.$store.state.micro.microRouter;
    },

  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  data() {
    return {
      currentMenu1Index: -1,
      currentMenu2Index: -1,
      m1: {},
      showIcon: true,
      isLockMenus: false,
    }
  },
  watch: {
    menus(newVal) {
      let a = false
      newVal.forEach((item, index) => {
        // 设置默认选中的一级菜单
        if (item.hasOwnProperty("menuname")) {
          if (item.menuname === localStorage.getItem("defaultLevel1Menu")) {
            this.clickMenuItem(item, index)
            a = true
          }
        }
      })
      if (!a) {
        // const sessionTab = JSON.parse(sessionStorage.getItem("kk-tab"))
        const sessionTab = this.$store.state.system.tab
        const activeTab = sessionTab && sessionTab.find(item => item.active === true)
        if(activeTab && activeTab.fatherId) {
          let newIndex = newVal.findIndex(item => item.menuid === activeTab.fatherId)
          newIndex !== -1 ? this.clickMenuItem(newVal[newIndex], newIndex) : this.clickMenuItem(newVal[0], 0)
        } else {
          this.clickMenuItem(newVal[0], 0)
        }
      }
    },
    microRouter(to) {
      // 当tag切换时，监听路由变化，控制menu状态
      if(!this.isLockMenus) {   // 防止在menu切换时调用
        if(to.fatherId) {
          if(to.fatherId.length == '3') {   // 二级菜单
            this.menus2.forEach(item => {
              this.$set(item, "active", false)
            })
            const index = this.menus2.findIndex(item => item.menuname == to.name)
            this.$set(this.menus2[index], "active", true)

          } else if(to.fatherId.length == '5') {   // 三级菜单
            // 二级菜单active
            this.menus2.forEach(item => {
              this.$set(item, "active", false)
            })
            const index = this.menus2.findIndex(item => item.menuid == to.fatherId)
            this.$set(this.menus2[index], "active", true)

            // 三级菜单active
            this.menus2[index].children.forEach(item => {
              this.$set(item, "active", false)
            })
            const childIndex = this.menus2[index].children.findIndex(item => item.url == to.url)
            this.$set(this.menus2[index].children[childIndex], "active", true)

          } else {
            console.error('这是个不可忽视的错误,父级id格式错误')
          }

        } else if(to.url == "general") {
          // 特殊处理 monitor(skyWalking)子应用
        } else {
          console.error('这是个不可忽视的错误,menu的父级id不存在', to);
        }
      }
    },

  },
  created() {
  },
  methods: {
    ...mapMutations(['SET_SHOWAPP', 'SET_MICROROUTER']),
    isChildrenActive(m2) {
      let a = false
      if (m2.children) {
        m2.children.forEach((item) => {
          if (item.url && this.$route.path.startsWith('/main/' + item.url)) {
            a = true
          }
        })
      }
      return a
    },
    isActive(m3) {
      setTimeout(() => {
        return m3.url && this.$route.fullPath.includes(m3.url);
      }, 100)
    },
    elementType(m2, isParent = true) {
      if (m2.url) {
        // return "router-link";
        return "span";
      } else {
        return "a";
      }
    },
    clickMenuItem(m1, index) {
      this.currentMenu2Index = -1
      this.currentMenu1Index = index
      this.m1 = m1
      this.$nextTick(() => {
        this.$emit("reinitScrollbar")
      })

      // 切换子应用（仅当子应用不一样时进行切换）
      if(m1.module) {
        const { module } = this.$store.state.micro.showApp
        if(module !== m1.module) {
          this.SET_SHOWAPP(m1)
        }
      }

      // 展開三級菜單
      let openM2 = this.m1.children.find(item => (item.children && item.children.length > 0));
      if(typeof openM2 !== 'undefined' && openM2) {
        this.menus2.forEach(item => {
          this.$set(item, "active", false)
          if(item.menuid === openM2.menuid) {
            this.$set(item, "active", true)
          }
        })
      }
    },
    clickMenu2Item(m2, index) {
      // 特殊处理 monitor(skyWalking)子应用

      if(m2.menuid == "M0903") {
        console.log('特殊处理 monitor(skyWalking)子应用', m2);

        this.SET_SHOWAPP(m2)
        this.$router.push({name: 'monitor', params: JSON.parse(JSON.stringify(m2))})
        this.menus2.forEach(item => {
           this.$set(item, "active", false)
        })
        this.$set(this.menus2[index], "active", true)
        return false
      }

      if(this.m1.module) {
        const { module } = this.$store.state.micro.showApp
        if(module !== this.m1.module) {
          this.SET_SHOWAPP(this.m1)
        }
      }

      // 加锁
      this.isLockMenus = true
      // 判断当前路由是否为子路由的根路由
      let m2Data = JSON.parse(JSON.stringify(m2));
      m2Data.father = this.m1.module
      m2Data.fatherId = this.m1.menuid
      if(m2Data.children && m2Data.children.length > 0) {     // 存在子菜单，不进行页面跳转
        this.$set(this.menus2[index], "m3Active", true)
        if(this.menus2[index].active) {   // 展开状态时，关闭
          this.menus2.forEach(item => {
            this.$set(item, "active", false)
          })
        } else {    // 关闭状态时，展开
          this.menus2.forEach(item => {
            this.$set(item, "active", false)
          })
          this.$set(this.menus2[index], "active", true);
        }
        this.isLockMenus = false;   // 解锁
      } else {
        this.$set(this.menus2[index], "m3Active", false)
        if(m2Data.module) {   // 二级menu下有指定module子应用，使用该子应用
          this.jupSubFunc(m2Data, m2Data.module)
        } else if(m2Data.father) {    // 二级menu下没有指定module子应用，使用父级子应用
          this.jupSubFunc(m2Data, m2Data.father)
        } else {
          console.error('这是个不可忽视的错误，menu.module中没有关联子应用')
        }
        this.menus2.forEach(item => {
           this.$set(item, "active", false)
        })
        this.$set(this.menus2[index], "active", true)
        // 解锁
        setTimeout(() => {this.isLockMenus = false}, 100)
      }
    },
    clickMenu3Item(m2, m3, index, m3Index) {
      // 加锁
      this.isLockMenus = true
      // 判断当前路由是否为子路由的根路由
      const path = this.$route.path
      let m3Data = JSON.parse(JSON.stringify(m3));
      m3Data.father = m2.module
      m3Data.fatherId = m2.menuid

      if(m3Data.module) {   // 三级menu下有指定module子应用，使用该子应用
          this.jupSubFunc(m3Data, m3Data.module)
        } else if(m3Data.father) {    // 三级menu下没有指定module子应用，使用父级子应用
          this.jupSubFunc(m3Data, m3Data.father)
        } else {
          console.error('这是个不可忽视的错误，menu.module中没有关联子应用')
        }
        this.menus2[index].children.forEach(item => {
           this.$set(item, "active", false)
        })
        this.$set(this.menus2[index].children[m3Index], "active", true)
        this.$set(this.menus2[index], "m3Active", true)
        // 解锁
        setTimeout(() => {this.isLockMenus = false}, 100)
    },
    jupSubFunc(menuData, module) {
      const {path} = this.$route;
      if((path.indexOf(module) == -1)) {
          // 路由不一致， 切换子组件根路径，再进行跳转
          this.$router.push({name: module, params: menuData})
        } else {
          // 跳转子应用对应的路由
          this.SET_MICROROUTER(menuData)
        }

    },

    minimizeSidebar() {
      if (this.$sidebar) {
        this.$nextTick(() => {
          this.showIcon = !!this.$sidebar.isMinimized
        })
        this.$sidebar.toggleMinimize();
      }
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/k-menu/k-sider.vue